import { z } from "zod"

import { FormatKey } from "@/lib/types"

const MAX_DESCRIPTION_LENGTH = 100
const MAX_TAB_TRIGGER_LENGTH = 50
const MAX_SNIPPET_LENGTH = 3000
const MAX_SCOPE_LENGTH = 100

export const formSchema = z.object({
  description: z
    .string()
    .min(1, { message: "Description is required." })
    .max(MAX_DESCRIPTION_LENGTH, {
      message: `Description must be at most ${MAX_DESCRIPTION_LENGTH} characters.`,
    }),
  tabTrigger: z
    .string()
    .min(1, { message: "Tab trigger is required." })
    .max(MAX_TAB_TRIGGER_LENGTH, {
      message: `Tab trigger must be at most ${MAX_TAB_TRIGGER_LENGTH} characters.`,
    }),
  snippet: z
    .string()
    .min(1, { message: "Snippet cannot be empty." })
    .max(MAX_SNIPPET_LENGTH, {
      message: `Snippet must be at most ${MAX_SNIPPET_LENGTH} characters.`,
    }),
  format: z.enum(Object.values(FormatKey)),
  scope: z.string().max(MAX_SCOPE_LENGTH).optional(),
})

export {
  MAX_DESCRIPTION_LENGTH,
  MAX_SCOPE_LENGTH,
  MAX_SNIPPET_LENGTH,
  MAX_TAB_TRIGGER_LENGTH,
}
export type FormValues = z.infer<typeof formSchema>
